import AddressVerifiedChip from './AddressVerifiedChip';

export default AddressVerifiedChip;
